<div class="cart-wrapper">
  <button  class="close-btn data-protection-close delete-cart-popup-btn" mat-icon-button aria-label="close dialog" mat-dialog-close>
    <mat-icon><div class="close"><img src="/icons/close.svg" alt="" width="20" height="20" /></div></mat-icon>
</button>
  <mat-dialog-content class="delete-cart-dialog">
      <div class="confirm-text">
        {{'common.cart_product_deleteall'|cxTranslate}}
      </div>
  </mat-dialog-content>
  <mat-dialog-actions class="col-12 delete-confirm-action">
      <button class="mat-primary  mat-accept delete-cart-confirmation" (click)="accept()" mat-button>{{'common.cart_page_checkout_yes'|cxTranslate}}</button>
      <button class="mat-primary  mat-accept no-delete" (click)="close()" mat-button>{{'common.cart_page_checkout_no'|cxTranslate}}</button>
  </mat-dialog-actions>
</div>
